<template>
	<div class="view pa24">
		<el-form :model="serchParams" class="demo-form-inline" :inline="true">
			<el-row style="padding-top: 20px;">
				<el-form-item  label="分销商" label-width="100px" label-position="left"
					class="fromItem" prop="dealerId">
					<el-select v-model="serchParams.dealerId" placeholder="请选择" filterable @change="chooseDl" clearable>
						<el-option v-for="item in dlOptions" :key="item.id" :label="item.dealerName"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
        <el-form-item label="商品名称" label-width="100px" label-position="left"
                      class="fromItem" prop="dealerId">
          <el-select v-model="serchParams.classId" placeholder="请选择商品" filterable @change="classIdChange" style="width: 352px" clearable>
            <el-option
                v-for="item in classOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品编码" label-width="100px" label-position="left"
                      class="fromItem" prop="dealerId">
          <el-input v-model="serchParams.goodsCode" placeholder="请输入商品编码" clearable></el-input>
        </el-form-item>
				<el-button type="primary" @click="search">搜索</el-button>
				<el-button @click="resetSearch">重置</el-button>
			</el-row>
      <el-button :loading="exportLoadding" icon="el-icon-download" type="warning" @click="exportLog">导出</el-button>

		</el-form>
		<commonTable :tableData="tableData" :total="total" :currentPage="pageNum" :loading="tableLoading" @handleSizeChange="handleSizeChange"
			@handleCurrentChange="handleCurrentChange">
			<template v-slot:table>
				<el-table-column prop="dealerName" align="center" label="分销商名称" />
				<el-table-column prop="dealerCode" align="center" label="分销商代号" />
				<el-table-column prop="className" align="center" label="商品名称" />
				<el-table-column prop="goodsCode" align="center" label="商品编码" />
				<el-table-column prop="specCode" align="center" label="规格型号" />
				<el-table-column prop="packNum" align="center" label="库存数量" />
				<el-table-column prop="num" align="center" label="单位" >
          <template>盒</template>
        </el-table-column>
			</template>
		</commonTable>
  <out-detail ref="detail"></out-detail>
	</div>
</template>

<script>
	import commonTable from "@/components/common/commonTable";
  import outDetail from "@/pages/dealerLog/componenets/outDetail.vue";
  import {
    dealerDetailLog, dealerStockDetail,exportDealerStock,getAllDealer
  } from '@/api/crk.js'
  import {pageClass} from "@/api/customPageClass";
	export default {
		name: "dealerOutLog",
		components: {
			commonTable,outDetail
		},
		data() {
			return {
				tableData: [],
				pageSize: 10,
				pageNum: 1,
				total: 0,
				serchParams: {
          dealerId: '',
          classId:'',
          goodsCode:'',
				},
				dealerOptions: [],
				dlOptions: [],
        exportLoadding:false,
        options:[
          {value:1,label:'分销入库'},
          {value:2,label:'分销出库'},
          {value:3,label:'分销退货'},
        ],
        statusOptions:[
            {value:1,label:'已完成'},
        ],
        loading: false,
        tableLoading: false,
        classOptions:[]
			};
		},
		created() {
			// 获取所有代理商、经销商列表
      this.getDlList()
      this.getAllClass()
      this.getList()
		},
    filters: {
      statusFormat(value,list){
        let label = ''
        list.forEach(item=>{
          if(item.value == value){
            label = item.label
          }
        })
        return label
      }
    },
		methods: {
      getAllClass(){
        pageClass().then(res=>{
          this.classOptions = res.data
        })
      },
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options = this.list.filter(item => {
              return item.label.toLowerCase()
                  .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options = [];
        }
      },
			classIdChange() {

			},
			copy(context) {
				// 创建输入框元素
				let oInput = document.createElement('input');
				// 将想要复制的值
				oInput.value = context;
				// 页面底部追加输入框
				document.body.appendChild(oInput);
				// 选中输入框
				oInput.select();
				// 执行浏览器复制命令
				document.execCommand('Copy');
				// 弹出复制成功信息
				this.$message.success('复制成功');
				// 复制后移除输入框
				oInput.remove();
			},
			handleSizeChange(num) {
				this.pageSize = num;
				this.pageNum = 1;
				this.getList();
			},
			handleCurrentChange(num) {
				this.pageNum = num;
				this.getList();
			},
			// 过滤掉空的children
			formatData(data) {
				for (var i = 0; i < data.length; i++) {
					if (data[i].children == null || data[i].children.length == 0) {
						data[i].children = undefined;
					} else if (data[i].children.length > 1) {
						this.formatData(data[i].children);
					}
				}
				return data;
			},
			getDealerList(parentId) {
        getDealerList({type:2,parentId:parentId,isJk: true}).then(res=>{
          this.dealerOptions = res.data
        })
			},
      getDlList() {
        getAllDealer({isJk: true}).then(res=>{
          this.dlOptions = res.data
        })
      },
			search() {
				this.pageNum = 1
				this.getList()
			},
			resetSearch() {
				this.serchParams.dealerId = ''
        this.serchParams.classId = ''
        this.serchParams.goodsCode = ''
				this.pageNum = 1
				this.getList()
			},
			getList() {
				this.tableLoading = true
				let params = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					dealerId: this.serchParams.dealerId,
          classId: this.serchParams.classId,
          goodsCode: this.serchParams.goodsCode,
				}
        dealerStockDetail(params).then(res => {
					this.tableData = res.data.list
					this.total = res.data.total
				}).finally(() => {
					this.tableLoading = false
				})
			},
      chooseDl(){
        this.serchParams.toDealerId = ''
        this.getDealerList(this.serchParams.fromDealerId)
      },
      goDetail(row){
        this.$refs.detail.init(row.id)
      },
      exportLog(){
        this.exportLoadding = true
        let params={
          dealerId: this.serchParams.dealerId,
          classId: this.serchParams.classId,
          goodsCode: this.serchParams.goodsCode,
        }
        exportDealerStock(params).then(result=>{
          this.exportLoadding = false
          const url = window.URL.createObjectURL(result.data);
          const temp =result.fileName.split(";")[1].split("filename=")[1];
          const fileName = decodeURIComponent(temp)
          const link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName );
          document.body.appendChild(link);
          link.click();
        }).catch(e=>{
          this.exportLoadding = false
          this.$message.error(e.message)
        })
      }
		}
	}
</script>

<style lang="scss" scoped>
	.name_status {
		display: inline-block;
		width: 26px;
		height: 17px;
		line-height: 15px;
		background: rgba(63, 114, 246, 0.11);
		border: 1px solid #3F72F6;
		border-radius: 4px;
		font-size: 12px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3F72F6;
		text-align: center;
	}

	.name_status1 {
		display: inline-block;
		width: 26px;
		height: 17px;
		line-height: 15px;
		background: rgba(243, 136, 46, 0.11);
		border: 1px solid #F3882E;
		border-radius: 4px;
		font-size: 12px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #F3882E;
		text-align: center;
	}

	.copyTxt {
		display: inline-block;
		margin-left: 5px;
		cursor: pointer;
		color: #3F72F6;
	}
</style>
